import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AutoFocusInside } from 'react-focus-lock';
import { useDebounce } from 'use-debounce';
import { useFetchContentUsersAndTeams } from 'actions/content';
import Text from 'components/Text';
import FormField from 'components/FormField';
import MultiSelect from 'components/MultiSelect';
var DEBOUNCE_INTERVAL = 200;
function ShareWithUsersWidget(_ref) {
  var data = _ref.data,
    recipients = _ref.recipients,
    onChangeRecipients = _ref.onChangeRecipients;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useDebounce = useDebounce(searchValue, DEBOUNCE_INTERVAL),
    _useDebounce2 = _slicedToArray(_useDebounce, 1),
    debouncedSearchValue = _useDebounce2[0];
  // Only use a debounced value if a search term exists
  // This prevents a laggy UI when clearing the search
  var searchQuery = searchValue ? debouncedSearchValue : '';
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    alert = _useState4[0],
    setAlert = _useState4[1];
  var playlistIds = data.playlistIds,
    assetIds = data.assetIds;
  var _useFetchContentUsers = useFetchContentUsersAndTeams({
      search: searchQuery,
      playlistIds: playlistIds,
      assetIds: assetIds,
      enabled: searchQuery.trim().length > 0
    }),
    isLoading = _useFetchContentUsers.isLoading,
    usersAndTeams = _useFetchContentUsers.data;
  var recipientOptions = (usersAndTeams === null || usersAndTeams === void 0 ? void 0 : usersAndTeams.users.map(function (user) {
    return {
      title: user.first_name && user.last_name ? "".concat(user.first_name, " ").concat(user.last_name) : user.name,
      value: user.name,
      icon: 'user',
      id: user.id
    };
  })) || [];
  function addRecipient(newRecipient) {
    setAlert('');
    setSearchValue('');
    onChangeRecipients([].concat(_toConsumableArray(recipients), [newRecipient]));
  }
  function removeRecipient(item) {
    var updatedRecipients = recipients.filter(function (recipient) {
      return recipient.value.indexOf(item.value) === -1;
    });
    onChangeRecipients(updatedRecipients);
  }
  return /*#__PURE__*/React.createElement(AutoFocusInside, null, /*#__PURE__*/React.createElement(FormField, {
    required: true,
    label: t('share_widget_title'),
    alert: alert
  }, /*#__PURE__*/React.createElement(MultiSelect, {
    "aria-describedby": "recipients-description",
    inputValue: searchValue,
    selectedItems: recipients,
    options: recipientOptions,
    optionsLabel: t('share_widget_options'),
    emptyMenuMessage: isLoading ? t('loading') : t('share_no_users_found'),
    onInputValueChange: setSearchValue,
    onSelectItem: addRecipient,
    onRemoveItem: removeRecipient
  }), /*#__PURE__*/React.createElement(Text, {
    dimmed: true,
    size: "s",
    id: "recipients-description"
  }, t('share_widget_message'))));
}
export default ShareWithUsersWidget;